import React from 'react';
import classnames from 'classnames';
import FooterNavigation from './components/FooterNavigation';
import FooterContacts from './components/FooterContacts';
import FooterInfo from './components/FooterInfo';
import DataSocials from '@/mocks/socials';
import * as styles from './footer.module.scss';
import './styles.scss';

// import useDeviceState from "@/hooks/useDeviceState";
// import { TABLET_KEY } from "@/constants/devices";

const Footer = ({ footerData: { navigation, info, contacts } }) => {
  // const deviceState = useDeviceState();

  return (
    <footer className={classnames(styles.footer)}>
      <div className={classnames(styles.inner, 'cr-wrap')}>
        <FooterNavigation navigation={navigation} />
        <FooterContacts DataSocials={DataSocials} contacts={contacts} />
        <FooterInfo info={info} />
      </div>
    </footer>
  );
};

export default Footer;
